<template>
  <v-menu offset-y v-model="open" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        color="background: rgba(251, 109, 59, 0.15)"
        class="avatar-text"
        size="50"
        v-bind="attrs"
        v-on="on"
      >
        <span style="" class="text-white" v-if="user">
          {{ toLatin(user.name.charAt(0).toUpperCase()) }}
          {{
            user.lastname != null ? toLatin(user.lastname.charAt(0).toUpperCase()) : ""
          }}
        </span>
      </v-avatar>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in reportGuestMenuItems"
        :key="index"
        @click="navigate(item.to)"
      >
        <v-list-item-title>
          <v-icon v-html="item.icon" small class="pr-2"></v-icon>
          {{ $t(item.title) }}
        </v-list-item-title>
      </v-list-item>

      <!-- Mobile only: the app bar hides language + logout below desktop width. -->
      <template v-if="!device.isDesktop">
        <v-divider class="my-1"></v-divider>
        <v-list-item v-if="availableLanguages.length > 1">
          <language-selector
            component-type="autocomplete"
            dense
            component-class="my-1"
            @setLang="$emit('set-lang', $event)"
          />
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-title>
            <v-icon small class="pr-2">mdi-logout</v-icon>
            {{ $t("logout") }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import LanguageSelector from "@/components/layout/LanguageSelector.vue";

export default {
  name: "AppReportGuestAvatarMenu",
  components: {
    LanguageSelector,
  },
  props: {
    availableLanguages: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    open: false,
  }),
  methods: {
    navigate(to) {
      this.open = false;
      this.$router.push(to);
    },
    logout() {
      this.open = false;
      this.$emit("logout");
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },

    reportGuestMenuItems() {
      return [
        {
          title: this.$t("guest_report"),
          icon: "mdi-home",
          to: { name: "guest-report" },
        },
        {
          title: "Инфо",
          icon: "mdi-information ",
          to: { name: "info" },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.avatar-text {
  color: $primary-color;
  font-size: 13px;
}
</style>
